const flutterProducts = {
  en: {
    flutterProducts: {
      text1: 'Processing within 3 minutes',
      text2: 'Choice of territory: World countries, All over the World',
      text3: 'Wide range of medical services',
      text4: 'Protection from Covid-19',
      text5: '24/7 Insurance',
      accident1: 'Amount Insured from 100 000 KZT to 2 000 000 KZT',
      accident2: 'Premium from 750 KZT',
      accident3: 'Sports as an additional risk',
      accident4: 'Choice of territory: RoK, CIS countries, All over the World',
      accident5: 'Age from 1 year to 65',
      text11: 'Purchase',
      text12: 'Purchase policy',
      text13: 'Insurance event',
      text14: 'My policies',
      text15: 'My benefits',
      casco1: 'Programs: Economy class, Business class, VIP ',
      casco2: 'Sum insured from 500 000 to 50 000 000 KZT',
      casco3: 'Vehicle types: passenger, cargo, construction equipment, etc.',
      casco4: 'Premium starts from 6 000 KZT',
      casco5: 'The insurance period: 12 months',
      dgpo1: 'Sum insured from 500 000 to 1 000 000 KZT',
      dgpo2: 'Vehicle types: Passenger, cargo, construction equipment, etc.',
      dgpo3: 'Insurance territory: Republic of Kazakhstan',
      dgpo4: 'Tariff starts with 0,23-0,43%',
      carrier1: 'Sum insured from 1 000 000 to 10 000 000 KZT',
      carrier2: 'Vehicle types: Passenger, buses, minibuses',
      carrier3: 'Insurance territory: Republic of Kazakhstan',
      carrier4: 'Tariff starts with 0,25%',
      flat1: 'Sum insured from 1 000 000 to 100 000 000 KZT',
      flat2: 'The insurance period is from 6 to 12 months',
      flat3: 'Tariff is 0,15%',
      flat4: 'Unconditional franchise 0.3%',
      neighbor1: 'Sum insured from 300 000 to 3 000 000 KZT',
      neighbor2: 'The insurance period is from 6 to 12 months',
      neighbor3: 'Tariff starts with 0,8%',
      neighbor4: 'Premium starts from 3500 KZT',
      athletes1: 'Amount Insured from 100 000 KZT to 2 000 000 KZT',
      athletes2: 'Premium from 560 KZT',
      children1: 'Amount Insured from 100 000 KZT to 2 000 000 KZT',
      children2: 'Premium from 500 KZT',
      children3: 'Age from 1 year to 17',
      nonresident1: 'Amount Insured from 50 000 KZT to 300 000 KZT',
      nonresident2: 'Premium from 1 200 KZT',
      nonresident3: 'Insurance territory: Republic of Kazakhstan',
      nonresident4: 'Age from 18 year to 65',
    },
  },
  kz: {
    flutterProducts: {
      text1: '3 минут ішінде рәсімдеу',
      text2: 'Таңдау аумағы: Әлем елдері, Бүкіл әлем',
      text3: 'Медициналық қызметтердің кең ауқымы',
      text4: 'Covid-19 қорғау',
      text5: '24/7 сақтандыру',
      accident1: 'Сақтандыру сомасы 100 000 теңгеден 2 000 000 теңгеге дейін',
      accident2: 'Сыйлықақы 750 теңгеден бастап',
      accident3: 'Қосымша тәуекел ретінде спорт',
      accident4: 'Таңдау аумағы: ҚР, ТМД елдері, Бүкіл әлем',
      accident5: '1 жастан 65 жасқа дейін',
      text11: 'Сатып алу',
      text12: 'Полисті сатып алу',
      text13: 'Сақтандыру жағдайы',
      text14: 'Менің полистерім',
      text15: 'Менің төлемдерім',
      casco1: 'Программалар: Economy class, Business class, VIP',
      casco2: 'Сақтандыру соммасы: 500 000 бастап 50 000 000 тг дейін',
      casco3: 'КҚ түрлері: жеңіл, жүк көліктері, құрылыс техникасы, т.б.',
      casco4: 'Сыйақы: 6 000 тг-ден бастап',
      casco5: 'Сақтандыру мерзімі: 12 ай',
      dgpo1: 'Сақтандыру соммасы: 500 000 бастап 1 000 000 тг дейін',
      dgpo2: 'КҚ түрлері: жеңіл, жүк көліктері, құрылыс техникасы, т.б.',
      dgpo3: 'Сақтандыру аумағы: Қазақстан Республикасы',
      dgpo4: 'Тариф 0,23-0,43% бастап',
      carrier1: 'Сақтандыру соммасы: 1 000 000 бастап 10 000 000 тг дейін',
      carrier2: 'КҚ түрлері: жеңіл көліктер, автобустар, шағын автобустар',
      carrier3: 'Сақтандыру аумағы: Қазақстан Республикасы',
      carrier4: 'Тариф 0,25% бастап',
      flat1: 'Сақтандыру соммасы: 1 000 000 бастап 100 000 000 тг дейін',
      flat2: 'Сақтандыру мерзімі: 6 айдан 12 айға дейін',
      flat3: 'Тариф 0,15%',
      flat4: 'Шартсыз шегерім 0,3% ',
      neighbor1: 'Сақтандыру соммасы: 300 000 бастап 3 000 000 тг дейін',
      neighbor2: 'Сақтандыру мерзімі: 6 айдан 12 айға дейін',
      neighbor3: 'Тариф 0,8% бастап',
      neighbor4: 'Сыйақы: 3500 тг-ден бастап',
      athletes1: 'Сақтандыру сомасы 100 000 теңгеден 2 000 000 теңгеге дейін',
      athletes2: 'Сыйлықақы 560 теңгеден бастап',
      children1: 'Сақтандыру сомасы 100 000 теңгеден 2 000 000 теңгеге дейін',
      children2: 'Сыйлықақы 500 теңгеден бастап',
      children3: '1 жастан 17 жасқа дейін',
      nonresident1: 'Сақтандыру сомасы 50 000 теңгеден 300 000 теңгеге дейін',
      nonresident2: 'Сыйлықақы 1 200 теңгеден бастап',
      nonresident3: 'Сақтандыру аумағы: Қазақстан Республикасы',
      nonresident4: '18 жастан 65 жасқа дейін',
    },
  },
  ru: {
    flutterProducts: {
      text1: 'Оформление за 3 минуты',
      text2: 'Территория на выбор: Страны мира, Весь мир',
      text3: 'Широкий спектр медицинских услуг',
      text4: 'Защита от Covid-19',
      text5: 'Страховка 24/7',
      accident1: 'Страховая сумма от 100 000 до 2 000 000 тенге',
      accident2: 'Премия от 750 тенге',
      accident3: 'Спорт как дополнительный риск',
      accident4: 'Территория на выбор: РК, Страны СНГ, Весь мир',
      accident5: 'Возраст от 1 года до 65 лет',
      text11: 'Купить',
      text12: 'Купить полис',
      text13: 'Страховой случай',
      text14: 'Мои полисы',
      text15: 'Мои выплаты',
      casco1: 'Программы: Economy class, Business class, VIP',
      casco2: 'Страховая сумма от 500 000 до 50 000 000 тг',
      casco3: 'Типы ТС: легковые, грузовые, строительная техника и т.д.',
      casco4: 'Премия от 6 000 тг',
      casco5: 'Срок страхования: 12 месяцев',
      dgpo1: 'Страховая сумма: от 500 000 до 1 000 000 тг',
      dgpo2: 'Типы ТС: легковые, грузовые, строительная техника и т.д.',
      dgpo3: 'Территория страхования: Республика Казахстан',
      dgpo4: 'Тариф от 0,23-0,43%',
      carrier1: 'Страховая сумма: от 1 000 000 до 10 000 000 тг',
      carrier2: 'Типы ТС: легковые, автобусы, микроавтобусы',
      carrier3: 'Территория страхования: Республика Казахстан',
      carrier4: 'Тариф от 0,25%',
      flat1: 'Страховая сумма: от 1 000 000 до 100 000 000 тг',
      flat2: 'Срок страхования: от 6 до 12 месяцев',
      flat3: 'Тариф 0,15%',
      flat4: 'Безусловная франшиза 0,3%',
      neighbor1: 'Страховая сумма: от 300 000 до 3 000 000 тг',
      neighbor2: 'Срок страхования: от 6 до 12 месяцев',
      neighbor3: 'Тариф от 0,8%',
      neighbor4: 'Премия от 3500 тг',
      athletes1: 'Страховая сумма от 100 000 до 2 000 000 тенге',
      athletes2: 'Премия от 560 тенге',
      children1: 'Страховая сумма от 100 000 до 2 000 000 тенге',
      children2: 'Премия от 500 тенге',
      children3: 'Возраст от 1 года до 17 лет',
      nonresident1: 'Страховая сумма от 50 000 до 300 000 тенге',
      nonresident2: 'Премия от 1 200 тенге',
      nonresident3: 'Территория страхования: Республика Казахстан',
      nonresident4: 'Возраст от 18 до 65 лет',
    },
  },
};

export default flutterProducts;
